<template>
    <div class="main-wrap">
        <div class="pctitle">
            <img class="fmdlogo" src="/img/c1.png" alt="로고">
            <h4>고객을 위한<br>믿을 수 있는 대출 비교 <br class="hidebr">서비스 <br class="onbr">핀모든입니다</h4>
            <p>원하는 대출이 무엇이든, 어디서든 <br>간편하고 믿음직한 서비스를 <br class="hidebr">제공하겠습니다.</p>
            <swiper v-if="$utils.isNotNull(banner.main_banner_list) && banner.main_banner_list.length > 0"
                    :modules="modules"
                    :slides-per-view="1"
                    :space-between="20"
                    :centered-slides="false"
                    loop
                    autoplay
                    class="custom-swiper"
            >
                <swiper-slide v-for="bannerItem in banner.main_banner_list" :key="bannerItem.banner_seq"
                              @click="moveTo(bannerItem.banner_seq)">
                    <img :src="$utils.makeBase64ImgSrc(bannerItem.banner_img, 'png')" alt="메인 배너" style="cursor: pointer;"/>
                </swiper-slide>
            </swiper>
        </div>
        <div class="mctt">
            <div class="service scroll">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script setup>
import {onMounted, reactive} from 'vue';
import {$client, $utils} from "@/assets/js/utils";

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'

// 사용할 모듈들
const modules = [Navigation, Pagination, Scrollbar, A11y, Autoplay]

const banner = reactive({
    main_banner_list: null
});

const moveTo = async (bannerSeq) => {
    let param = {
        banner_seq: bannerSeq
    };

    await $client.post("/svc/partner/redirect/create", param, function(response) {
        window.location.href = response.url;
    });
}

onMounted(async () => {
    await $client.get("/svc/partner/banner/list?location=1", {}, function(response) {
        banner.main_banner_list = response;
    });
});
</script>

<style scoped>
.custom-swiper {
    height: auto;
    width: 100%; /* 전체 너비 사용 */
    max-width: 560px;
    margin: 0 auto;
    overflow: hidden; /* 넘치는 부분 안보이게 */
}

.swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    width: 100% !important;
    background-color: transparent;
}

.swiper-slide img {
    display: block;
    height: auto;
    width: auto;
    max-width: 100%;
}

/* Swiper wrapper overflow 설정 */
.custom-swiper :deep(.swiper-wrapper) {
    align-items: center;
}
</style>
